import { render, staticRenderFns } from "./discount-tabs.vue?vue&type=template&id=61ab85d2&scoped=true&"
import script from "./discount-tabs.vue?vue&type=script&lang=js&"
export * from "./discount-tabs.vue?vue&type=script&lang=js&"
import style0 from "./discount-tabs.vue?vue&type=style&index=0&id=61ab85d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ab85d2",
  null
  
)

export default component.exports